import React from "react";
import dayjs from "dayjs";

import { ReactComponent as ConversationAvatarIcon } from '../../images/conversation-avatar.svg'
import { s360ConfigService } from "../Services/S360Config";

import "../LandingPage/LandingPageStyleSheet.css";

function ConversationListCell(props) {
  const showConversation = () => {
    props.landingPageActions.checkAndStartNewConversationCometd(props.conversation);
  };

  const lastMessage = props.conversation?.lastMessage?.text ?? "";
  const timeStampString = props.conversation && Math.trunc(props.conversation.createdOn / 1000);
  const displayTime = timeStampString
    ? dayjs.unix(timeStampString).format("DD MMM h:mm a")
    : null;
  const agentDisplayName = props.conversation?.agentInfo?.firstName && props.conversation?.agentInfo?.lastName
    ?
    props.conversation.agentInfo.firstName + " " + props.conversation.agentInfo.lastName
    : s360ConfigService?.config?.sandBox ?  "xBert" :"Bot";

  return (
    <div className="s360-conversation-history-list-cell">
      <div
        className="s360-conversation-history-container"
        style={props.config?.customDesign?.conversationHistoryContainer}
        onClick={showConversation}
      >
        <div className="s360-conversation-history-agent-image-container">
          <div className="s360-conversation-history-agent-image-cell">
            <ConversationAvatarIcon />
          </div>
        </div>
        <div className="s360-conversation-history-agent-detail-container">
          <div
            className="s360-conversation-history-agent-detail-cell"
            style={props.config?.customDesign?.conversationHistoryAgentDetailCell}
          >
            <div
              className="s360-conversation-history-agent-details-name"
              style={props.config?.customDesign?.conversationHistoryAgentDetailsName}
            >
              {agentDisplayName}
            </div>
            <div className="s360-conversation-history-agent-message-time">
              {displayTime}
            </div>
          </div>
          <div className="s360-conversation-history-agent-message-content">
            {lastMessage.length > 5 ? lastMessage.substring(0, 100) : lastMessage}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversationListCell;
